import { PaymentMethod } from '../../../../../services/exports/Constants';

export default {
  payment_methods: {
    [PaymentMethod.Card]: 'Credit Card',
    [PaymentMethod.Sofort]: 'Sofort',
    [PaymentMethod.Giropay]: 'Giropay',
    [PaymentMethod.PayByBank]: 'Pay by bank',
    [PaymentMethod.SepaDebit]: 'EC-Card / IBAN',
    [PaymentMethod.Cash]: 'Cash',
    [PaymentMethod.Link]: 'Link',
    [PaymentMethod.StripeOther]: 'Other payment method',
  },
};
